import React, { useMemo } from 'react';
import { buildScheduleSections } from './planEditorViewModel';

const PlanScheduleGroup = ({ group, visibleItemIds, collapsed, onToggle, renderItem, getItemProps = () => ({}), hidden = false }) => {
  const schedule = useMemo(() => buildScheduleSections(group.items), [group.items]);
  const isVisible = item => visibleItemIds.has(String(item?._id));
  const weeklyVisible = schedule.days.some(day => day.items.some(isVisible));
  const otherVisible = schedule.otherItems.some(isVisible);

  const renderScheduleItem = (item, weeklyAgenda = false) => {
    const itemProps = getItemProps(item) || {};
    return (
      <li
        key={item._id}
        data-item-id={item._id}
        hidden={!isVisible(item)}
        {...itemProps}
        className={`plan-editor-item-row ${itemProps.className || ''}`.trim()}
      >
        {renderItem(item, { weeklyAgenda })}
      </li>
    );
  };

  return (
    <section className="plan-group" hidden={hidden}>
      <button type="button" className="plan-group-heading" onClick={onToggle} aria-expanded={!collapsed}>
        <span><strong>{group.label}</strong><small>{group.items.length}</small></span>
        <span aria-hidden="true" className={collapsed ? '' : 'is-open'}>›</span>
      </button>

      <div className="plan-group-body" hidden={collapsed}>
        {schedule.mode === 'weekly-agenda' ? (
          <>
            <div className="plan-weekly-schedule" hidden={!weeklyVisible}>
              <div className="plan-schedule-section-heading">
              <div><strong>Weekly schedule</strong><span>Filled days start activities · empty days are rest</span></div>
              <small>{group.items.length - schedule.otherItems.length} weekly</small>
            </div>
            <div className="plan-week-map" role="list" aria-label={`${group.label} weekly schedule`}>
              {schedule.days.map(day => {
                const visibleCount = day.items.filter(isVisible).length;
                return (
                  <span
                    key={day.id}
                    className={`plan-week-map-day ${visibleCount ? 'has-activities' : ''}`}
                    role="listitem"
                    aria-label={`${day.full}, ${visibleCount ? `${visibleCount} activit${visibleCount === 1 ? 'y' : 'ies'}` : 'rest'}`}
                  >
                    <b>{day.narrow}</b>
                    <i>{visibleCount || ''}</i>
                  </span>
                );
              })}
            </div>
            <div className="plan-weekly-agenda">
              {schedule.days.filter(day => day.items.length > 0).map(day => {
                const dayVisible = day.items.some(isVisible);
                return (
                  <section key={day.id} className="plan-week-day" data-day={day.id} hidden={!dayVisible} aria-labelledby={`${group.id}-${day.id}-label`}>
                    <h4 id={`${group.id}-${day.id}-label`} className="plan-week-day-label"><strong>{day.short}</strong></h4>
                    <ul className="item-list plan-week-day-items">{day.items.map(item => renderScheduleItem(item, true))}</ul>
                  </section>
                );
              })}
            </div>
            </div>
            {schedule.otherItems.length > 0 && (
              <div className="plan-other-schedules" hidden={!otherVisible}>
                <div className="plan-schedule-section-heading"><div><strong>Other schedules</strong><span>Daily, monthly, or custom cadence</span></div><small>{schedule.otherItems.length}</small></div>
                <ul className="item-list">{schedule.otherItems.map(item => renderScheduleItem(item, false))}</ul>
              </div>
            )}
          </>
        ) : (
          <ul className="item-list plan-standard-schedule">{schedule.otherItems.map(item => renderScheduleItem(item, false))}</ul>
        )}
      </div>
    </section>
  );
};

export default PlanScheduleGroup;
